import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7920d7f2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "box-profile" }
const _hoisted_2 = { class: "form-widget" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "header" }, "Sign In", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "description" }, "An email containing a sign in link will be sent.", -1))
const _hoisted_5 = { class: "input-item" }
const _hoisted_6 = ["disabled"]
const _hoisted_7 = ["value", "disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("form", {
      onSubmit: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.handleLogin && _ctx.handleLogin(...args)), ["prevent"]))
    }, [
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _hoisted_4,
        _createElementVNode("div", _hoisted_5, [
          _withDirectives(_createElementVNode("input", {
            class: "input-text",
            type: "email",
            required: "",
            placeholder: "Your email",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.email) = $event)),
            disabled: _ctx.loading
          }, null, 8, _hoisted_6), [
            [_vModelText, _ctx.email]
          ])
        ]),
        _createElementVNode("div", null, [
          _createElementVNode("input", {
            type: "submit",
            class: "button-30",
            value: _ctx.loading ? 'Loading...' : 'Send Login Link',
            disabled: _ctx.loading
          }, null, 8, _hoisted_7)
        ])
      ])
    ], 32)
  ]))
}